import { useMemo } from 'react'
import matchSorter from 'match-sorter'
import { useTable as useTableOriginal, useSortBy, useGroupBy, useExpanded, useFilters } from 'react-table7'

const useTable = props => {
	const { columns, data, groupBy = {}, sortBy } = props

	const filterTypes = useMemo(() => ({
		defaultFilter: (rows, id, filterValue) => {
			return matchSorter(rows, filterValue, { keys: columns.map(col => `original.${col.accessor}`) })
		}
	}), [columns])

	const defaultColumn = useMemo(() => ({
		filter: 'defaultFilter',
		width: 100
	}), [])

	const hiddenColumns = columns.reduce((outArr, { isVisible, id, Header }) => {
		if(isVisible === false) {
			outArr.push(id || Header)
		}
		return outArr
	}, [])

	return useTableOriginal({
		initialState: {
			groupBy: groupBy.columns,
			hiddenColumns,
			...(sortBy && { sortBy: columns.map(() => sortBy) })
		},
		columns,
		filterTypes,
		defaultColumn,
		data: data || []
	},
	useFilters,
	useGroupBy,
	useSortBy,
	useExpanded
	)
}

export default useTable
